import $ from 'jquery';
import svg4everybody from 'svg4everybody';
// import TypeIt from 'typeit';
import { Foundation } from './lib/foundation-explicit-pieces';
import gsap from 'gsap';

import { preloadImages } from './components/_utils';

svg4everybody();

$('.lang a').click(function () {
  const lang = this.innerText.toLowerCase();
  if (lang) {
    localStorage.setItem('lang', lang);
  }
});

// new TypeIt('.promo_type', {
//     strings: ['The Moment', 'Your life', 'The Opportunity'],
//     breakLines: false,
//     loop: true,
//     speed: 50,
//     loopDelay: [0, 5000],
//     nextStringDelay: [5000, 0],
//     deleteSpeed: 25
// }).go();

if ($('.header').length && !$('.header').hasClass('header--page')) {
  preloadImages([
    '/assets/img/promo/bg.jpg',
    '/assets/img/promo/bg-life.jpg',
    '/assets/img/promo/bg-oppo.jpg',
  ]);

  const tl = gsap.timeline({ repeat: -1 });
  tl.set('.promo_image', { className: 'promo_image' });
  tl.to('.promo_line--moment', { opacity: 1, duration: 0.5 });
  tl.to('.promo_line--moment', { opacity: 0, duration: 0.5 }, 5);
  tl.set('.promo_image', { className: 'promo_image promo_image--life' });
  tl.set('.menu--header', { className: 'menu menu--header menu--life' });
  tl.to('.promo_line--life', { opacity: 1, duration: 0.5 });
  tl.to('.promo_line--life', { opacity: 0, duration: 0.5 }, 10);
  tl.set('.menu--header', { className: 'menu menu--header' });
  tl.set('.promo_image', { className: 'promo_image promo_image--oppo' });
  tl.to('.promo_line--oppo', { opacity: 1, duration: 0.5 });
  tl.to('.promo_line--oppo', { opacity: 0, duration: 0.5 }, 15);
}

// const isMain =
//   location.pathname === '/' ||
//   location.pathname === '/kr/' ||
//   location.pathname === '/cn/';

new Foundation.Dropdown($('.social_menu'), {
  hover: true,
  hoverPane: true,
  alignment: 'right',
  position: 'top',
  hOffset: -8,
  vOffset: 5,
  // allowOverlap: Foundation.MediaQuery.atLeast('medium') ? true : false,
});

if (!localStorage.getItem('bithumb'))
  setTimeout(() => $('#bithumb').foundation('open'), 1000);
$('#bithumb').on('closed.zf.reveal', () => localStorage.setItem('bithumb', 1));
